module.exports = __webpack_public_path__ + "static/media/FAQ_Banner.706becbc.png";